import { render, staticRenderFns } from "./PrisonerSuspensions.vue?vue&type=template&id=58c032c8"
import script from "./PrisonerSuspensions.vue?vue&type=script&lang=js"
export * from "./PrisonerSuspensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports